
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<div data-name="searchingRegion"></div>\n<h2 data-name="resultsText" class="resultsPresenter-header"><span data-translate="weFound">We found</span> <span style="display: inline-block" data-name="resultsCount">0 <span data-translate="results">results</span></span> <span data-translate="forYourSearch">for your search</span></h2>\n<section data-name="resultsSection"></section>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
